export const applyOrientalBirdStyle = async (canvas, ctx, setMessage, language) => {
  // 화조화: 꽃과 새의 섬세한 표현
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 1. 기본 수묵화 처리
  for (let i = 0; i < data.length; i += 4) {
    const gray = Math.round(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2]);
    data[i] = gray;
    data[i + 1] = gray;
    data[i + 2] = gray;
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 섬세한 선묘 강조
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const lineData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const linePixels = lineData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 미세한 디테일 강화 (깃털, 꽃잎의 선)
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      // 8방향 그라디언트 검출
      const gradients = [];
      for (let dy = -1; dy <= 1; dy++) {
        for (let dx = -1; dx <= 1; dx++) {
          if (dx !== 0 || dy !== 0) {
            const neighborPos = ((y + dy) * canvas.width + (x + dx)) * 4;
            gradients.push(Math.abs(tempData[pos] - tempData[neighborPos]));
          }
        }
      }
      
      const maxGradient = Math.max(...gradients);
      
      // 미세한 변화도 감지하여 선묘 강화
      if (maxGradient > 15) {
        const lineStrength = Math.min(50, maxGradient * 2);
        for (let c = 0; c < 3; c++) {
          linePixels[pos + c] = Math.max(0, linePixels[pos + c] - lineStrength);
        }
      }
    }
  }
  
  ctx.putImageData(lineData, 0, 0);
  
  // 3. 담채 효과 (옅은 색채 추가)
  const colorData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const colorPixels = colorData.data;
  
  // 원본 색상 정보를 약하게 복원
  for (let i = 0; i < data.length; i += 4) {
    const originalR = data[i];
    const originalG = data[i + 1];
    const originalB = data[i + 2];
    const currentGray = linePixels[i];
    
    // 원본에서 색상이 강했던 부분에 약간의 색상 복원
    if (originalR > originalG + 20 && originalR > originalB + 20) {
      // 빨간색 계열 (꽃)
      colorPixels[i] = Math.min(255, currentGray + (originalR - currentGray) * 0.3);
      colorPixels[i + 1] = currentGray;
      colorPixels[i + 2] = currentGray;
    } else if (originalG > originalR + 20 && originalG > originalB + 20) {
      // 녹색 계열 (잎)
      colorPixels[i] = currentGray;
      colorPixels[i + 1] = Math.min(255, currentGray + (originalG - currentGray) * 0.2);
      colorPixels[i + 2] = currentGray;
    } else if (originalB > originalR + 20 && originalB > originalG + 20) {
      // 파란색 계열 (하늘, 물)
      colorPixels[i] = currentGray;
      colorPixels[i + 1] = currentGray;
      colorPixels[i + 2] = Math.min(255, currentGray + (originalB - currentGray) * 0.2);
    } else {
      // 중성색 유지
      colorPixels[i] = currentGray;
      colorPixels[i + 1] = currentGray;
      colorPixels[i + 2] = currentGray;
    }
  }
  
  ctx.putImageData(colorData, 0, 0);
  
  // 4. 전통적인 여백 효과
  const spaceData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const spacePixels = spaceData.data;
  
  // 밝은 부분을 더 밝게 하여 여백감 강조
  for (let i = 0; i < spacePixels.length; i += 4) {
    if (spacePixels[i] > 200) {
      for (let c = 0; c < 3; c++) {
        spacePixels[i + c] = Math.min(255, spacePixels[i + c] * 1.05 + 10);
      }
    }
  }
  
  ctx.putImageData(spaceData, 0, 0);
  
  // 5. 붓끝의 갈필 효과
  const brushData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const brushPixels = brushData.data;
  
  for (let i = 0; i < brushPixels.length; i += 4) {
    const x = (i / 4) % canvas.width;
    const y = Math.floor((i / 4) / canvas.width);
    
    // 선의 끝부분에서 갈필 효과
    if (brushPixels[i] < 180 && Math.random() > 0.95) {
      const dryBrushEffect = Math.random() * 40;
      for (let c = 0; c < 3; c++) {
        brushPixels[i + c] = Math.min(255, Math.max(0, brushPixels[i + c] + dryBrushEffect));
      }
    }
  }
  
  ctx.putImageData(brushData, 0, 0);
};